import { videoCreationMs } from '../services/videoFrames';

/** EXIF-dato «YYYY:MM:DD HH:MM:SS» → ms epoch (lokal). null hvis ugyldig. */
function exifDateToMs(s?: string | null): number | null {
  if (!s) return null;
  const m = s.match(/^(\d{4}):(\d{2}):(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/);
  if (!m) return null;
  const ms = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]).getTime();
  return Number.isFinite(ms) && ms > 946684800000 ? ms : null;
}

/**
 * Ekte OPPTAKSDATO (ms epoch) for et bilde/videoklipp, til kronologisk
 * plassering i reisefilmen. Bilder: EXIF `DateTimeOriginal` via `exifreader`
 * (SAMME lib som AddSpotModal bruker for GPS). Video: MP4 `mvhd.created` (mp4box).
 * null → kalleren beholder File.lastModified (upålitelig for nedlastede/delte/
 * redigerte filer — eier-funn).
 */
export async function mediaCaptureMs(file: File): Promise<number | null> {
  try {
    if (file.type.startsWith('image/')) {
      const ExifReader = (await import('exifreader')).default;
      const tags: any = await ExifReader.load(await file.arrayBuffer(), { expanded: true });
      const dt = tags?.exif?.DateTimeOriginal?.description
        ?? tags?.exif?.CreateDate?.description
        ?? tags?.exif?.DateTime?.description;
      const ms = exifDateToMs(dt);
      if (ms) return ms;
    } else if (file.type.startsWith('video/')) {
      const ms = await videoCreationMs(file);
      if (ms) return ms;
    }
  } catch { /* fall til lastModified */ }
  return null;
}
